import message from '@/libs/message'

type ClaimErrorMessage = {
  type: 'warning' | 'error'
  content: string
}

export const INCOMPLETE_COVERAGE_DATA_ERROR_CODE = 'BIZECLMHCC1003'
export const INCOMPLETE_COVERAGE_DATA_MESSAGE =
  'ไม่ได้รับ interestType จาก PV กรุณาติดต่อ tech support'

export const CLAIM_ERROR_MESSAGES: Partial<Record<string, ClaimErrorMessage>> = {
  [INCOMPLETE_COVERAGE_DATA_ERROR_CODE]: {
    type: 'error',
    content: INCOMPLETE_COVERAGE_DATA_MESSAGE,
  },
  BIZECLAIM1011: {
    type: 'warning',
    content: 'กรมธรรม์อยู่ระหว่าง waiting period',
  },
  BIZECLAIM1007: {
    type: 'warning',
    content: 'วันที่เกิดเหตุไม่อยู่ในช่วงที่กรมธรรม์มีผลคุ้มครอง',
  },
  BIZECLAIM1008: {
    type: 'warning',
    content: 'ใช้สิทธิ์ OPD ครบตามจำนวนที่กำหนดในกรมธรรม์แล้ว',
  },
  BIZECLAIM1003: {
    type: 'warning',
    content: 'ทำรายการยื่นเคลมอุบัติเหตุนี้มาแล้ว',
  },
  BIZECLAIM1010: {
    type: 'warning',
    content: 'วันที่เข้ารับการรักษาหรือวันที่เกิดเหตุ อยู่หลังวันที่ชำระเบี้ย',
  },
  BIZECLAIM1002: {
    type: 'warning',
    content: 'ทำรายการยื่นเคลม OPD ของวันนี้ไปแล้ว',
  },
  BIZECLAIM1016: {
    type: 'warning',
    content: 'กรมธรรม์นี้ไม่มีความคุ้มครอง OPD',
  },
  BIZECLAIM1017: {
    type: 'warning',
    content: 'เคลม IPD ซ้ำกับที่มีบันทึกอยู่แล้วในระบบ',
  },
  BIZECLAIM1023: {
    type: 'warning',
    content: 'จำนวนที่คุ้มครองที่ระบุเกินกว่าวงเงินความคุ้มครอง',
  },
}

const DEFAULT_ERROR_MESSAGE: ClaimErrorMessage = {
  type: 'error',
  content: 'ส่งข้อมูลไม่สำเร็จ',
}

const MESSAGE_DURATION = 10

export const getClaimErrorCode = (error: unknown): string | null => {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response?: { data?: { code?: string } } }).response
    return response?.data?.code || null
  }

  return null
}

export const isIncompleteCoverageDataError = (error: unknown): boolean =>
  getClaimErrorCode(error) === INCOMPLETE_COVERAGE_DATA_ERROR_CODE

export const showClaimErrorNotification = (error: unknown) => {
  const errorCode = getClaimErrorCode(error)
  const errorMessage = errorCode ? CLAIM_ERROR_MESSAGES[errorCode] : undefined

  if (errorMessage) {
    message[errorMessage.type]({
      content: errorMessage.content,
      duration: MESSAGE_DURATION,
    })
    return
  }

  // Fallback on unknown error code
  if (errorCode) {
    message.error({
      content: `ส่งข้อมูลไม่สำเร็จ (Error code: ${errorCode})`,
      duration: MESSAGE_DURATION,
    })
    return
  }

  // Fallback on non-standard error object
  message[DEFAULT_ERROR_MESSAGE.type]({
    content: DEFAULT_ERROR_MESSAGE.content,
    duration: MESSAGE_DURATION,
  })
}
